<template>
    <div class="main">
        <c-panel title="CARTEIRINHA DO TRANSPORTE ESCOLAR" titleIcon="fas fa-bus">

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Emitir para">
                            <el-select v-model="aba" style="width:100%;">
                                <el-option label="Aluno individual" value="aluno"></el-option>
                                <el-option label="Aluno por turma" value="turma"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="aba === 'turma' && mostraInstituicao">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Instituição">
                            <el-select v-model="instituicaoSel" filterable clearable placeholder="Selecione a instituição" style="width:100%;">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="aba === 'aluno'">
                    <el-col :xs="24">
                        <el-form-item label="Aluno">
                            <el-select v-model="alunoId" filterable remote :remote-method="buscarAluno" :loading="loadAluno"
                                placeholder="Digite o nome..." style="width:100%;">
                                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="aba === 'turma'">
                    <el-col :xs="24">
                        <el-form-item label="Turma">
                            <el-select v-model="turmaId" filterable placeholder="Selecione" style="width:100%;">
                                <el-option v-for="t in turmas" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" style="text-align: right;">
                        <el-button type="primary" icon="el-icon-printer" :loading="gerando" :disabled="!podeGerar" @click="gerar">GERAR CARTEIRINHAS</el-button>
                    </el-col>
                </el-row>
            </el-form>

        </c-panel>
    </div>
</template>

<script>
/** Carteirinha do transporte escolar: individual ou por turma. PDF em nova aba. */
export default {
    data () {
        return {
            aba: 'aluno',
            alunoId: null, alunos: [], loadAluno: false,
            turmaId: null, turmas: [],
            instituicaoSel: null,
            gerando: false
        }
    },
    computed: {
        ehRede () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        mostraInstituicao () { return this.ehRede || !this.instHeader() },
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        podeGerar () {
            if (this.aba === 'aluno') return !!this.alunoId
            return !!this.turmaId
        }
    },
    mounted () { this.carregarTurmas() },
    watch: {
        '$store.state.config.instituicao.id' () { this.carregarTurmas() },
        instituicaoSel () { this.turmaId = null; this.carregarTurmas() }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instHeader () { const i = this.$store.state.config.instituicao; return i && i.id ? i.id : null },
        instId () { return this.instituicaoSel || this.instHeader() },

        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunos = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunos = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        carregarTurmas () {
            this.turmas = []

            const i = this.instId()
            const p = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null
            if (!i || !p) return

            this.$axios.get(`${this.baseUrl()}/api/turma/getAllTurmas/${i}/${p}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.turmas = Object.values(r.data || {}).reduce((todas, grupo) => todas.concat(grupo), [])
                        .sort((a, b) => a.nome.localeCompare(b.nome))
                })
                .catch(() => { this.turmas = [] })
        },
        gerar () {
            const base = `${this.baseUrl()}/api/carteirinha-transporte`
            const alvo = this.aba === 'aluno' ? `aluno/${this.alunoId}` : `turma/${this.turmaId}`

            this.gerando = true
            this.$axios.get(`${base}/${alvo}`, { ...this.$store.getters.getHeaderAuth, responseType: 'blob' })
                .then(r => {
                    this.gerando = false
                    const tipo = (r.headers && (r.headers['content-type'] || r.headers['Content-Type'])) || ''

                    // Erro de negócio volta como JSON em 200 OK.
                    if (tipo.indexOf('application/json') !== -1) {
                        const reader = new FileReader()
                        reader.onload = () => {
                            let msg = 'Falha ao gerar o PDF.'
                            try {
                                const obj = JSON.parse(reader.result)
                                if (obj && obj.erro) msg = typeof obj.erro === 'string' ? obj.erro : (obj.erro.text || msg)
                            } catch (e) { /* mantém a mensagem padrão */ }
                            window.eventBus.$emit('alert', { msg, type: 'warning' })
                        }
                        reader.readAsText(r.data)
                        return
                    }

                    const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                    const novaAba = window.open(url, '_blank')
                    if (!novaAba) window.location.href = url
                })
                .catch(e => { this.gerando = false; this.$store.commit('throwException', e) })
        }
    }
}
</script>
